import React, { useState } from 'react';
import Menu from '../../Menu';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Collapse from 'react-bootstrap/Collapse';
import PropTypes from 'prop-types';
import { itemType } from './helpers';
import { authLogout } from '~/stores/redux/common/authSlice';

function Sidebar() {
    const location = useLocation();

    const routeActive = (path) => {
        const routerPath = location.pathname.split('/')[1];

        if (
            path === routerPath ||
            (routerPath === '' && path === 'dashboard') ||
            (routerPath === 'dashboard' && path === 'dashboard')
        ) {
            return true;
        }
    };

    return (
        <aside className="aside-container">
            {/* START Sidebar (left) */}
            <div className="aside-inner">
                <nav className="sidebar">
                    {/* START sidebar nav */}
                    <ul className="sidebar-nav">
                        {/* Iterates over all sidebar items */}
                        {Menu.filter((item) => {
                            return item.isShown === 1;
                        }).map((item, i) => {
                            if (itemType(item) === 'menu') {
                                return (
                                    <SidebarItem
                                        isActive={routeActive(item.path) ?? false}
                                        item={item}
                                        key={i}
                                    />
                                );
                            }
                            if (itemType(item) === 'submenu') {
                                return (
                                    <SidebarSubItem
                                        item={item}
                                        isActive={routeActive(item.path) ?? false}
                                        key={i}
                                    >
                                        {item.submenu
                                            .filter((subitem) => subitem.isShown === 1)
                                            .map((subitem, i) => {
                                                return (
                                                    <SidebarItem
                                                        key={i}
                                                        item={subitem}
                                                        isActive={routeActive(subitem.path) ?? false}
                                                    />
                                                );
                                            })}
                                    </SidebarSubItem>
                                );
                            }
                        })}
                    </ul>
                    {/* END sidebar nav */}
                </nav>
            </div>
            {/* END Sidebar (left) */}
        </aside>
    );
}

const SidebarSubItem = ({ item, isActive, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <li className={isActive ? 'active' : ''}>
            <div
                className="nav-item"
                onClick={() => setIsOpen(!isOpen)}
            >
                {item.icon && <em className={item.icon}></em>}
                <span>{item.name}</span>
            </div>
            <Collapse
                in={isOpen}
                className={'pl-3'}
            >
                <ul className="sidebar-nav sidebar-subnav">{children}</ul>
            </Collapse>
        </li>
    );
};

SidebarSubItem.propTypes = {
    item: PropTypes.object.isRequired,
    isActive: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
};

const SidebarItem = ({ item, isActive }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleLogout = () => {
        // dispatch(authLogout(navigate));
        dispatch(authLogout(navigate));
    };

    return (
        <li className={isActive ? 'active' : ''}>
            {item.id === 'logout' ? (
                <a onClick={handleLogout}>
                    {item.icon && <em className={item.icon}></em>}
                    <span>{item.name}</span>
                </a>
            ) : (
                <Link
                    to={item.path}
                    title={item.name}
                >
                    {item.icon && <em className={item.icon}></em>}
                    <span>{item.name}</span>
                </Link>
            )}
        </li>
    );
};

SidebarItem.propTypes = {
    item: PropTypes.object.isRequired,
    isActive: PropTypes.bool.isRequired,
};

export default Sidebar;
